module.exports = "<div style=\"display: inline-block; width: calc(100% - 25px);\">\r\n  {{view Ember.ContainerView classNames=\"templates-table\"}}\r\n</div>"